import Button from 'components/Button';
import SmallSpinner from "components/SmallSpinner";
import Table from "components/Table";
import ColumnLayout from "components/ColumnLayout";

const documentedComponents = {
  Button,
  SmallSpinner,
  Table,
  ColumnLayout
};

export default documentedComponents;



// WEBPACK FOOTER //
// src/doc/docComponents.js